<div class="principles">
  <div class="principles--container">
    <h2 class="principles--title">Core Principles of the Agri Stack</h2>
    
    <div class="principles--grid">
      <div class="principle-card" *ngFor="let principle of principles">
        <div class="principle-card--icon">
          <!-- Domain Principles - Tree/Plant Icon (stacked shape with trunk) -->
          <svg *ngIf="principle.icon === 'domain'" width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L8 6L12 10L16 6L12 2Z" stroke="#047857" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 10L8 14L12 18L16 14L12 10Z" stroke="#047857" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 18V22" stroke="#047857" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <!-- Technology Principles - Circuit Board/Microchip Icon -->
          <svg *ngIf="principle.icon === 'technology'" width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="4" y="4" width="16" height="16" rx="2" stroke="#047857" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <circle cx="12" cy="12" r="3" stroke="#047857" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M4 8H8M16 8H20M4 16H8M16 16H20M8 4V8M16 4V8M8 16V20M16 16V20" stroke="#047857" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <!-- Governance Principles - Scales of Justice Icon -->
          <svg *ngIf="principle.icon === 'governance'" width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 3V21" stroke="#047857" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8 7L12 3L16 7" stroke="#047857" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <ellipse cx="7" cy="15" rx="2.5" ry="2" stroke="#047857" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <ellipse cx="17" cy="15" rx="2.5" ry="2" stroke="#047857" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7 17L17 17" stroke="#047857" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7 13L17 13" stroke="#047857" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <h3 class="principle-card--title">{{ principle.title }}</h3>
        <ul class="principle-card--list">
          <li class="principle-card--item" *ngFor="let item of principle.items">
            {{ item }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
